// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistLandingPage-cls1_LKg","cls2":"CoScientistLandingPage-cls2_RFE CoScientistLandingPage-cls1_LKg"};